import {ArticleView} from "./ArticleView.tsx";
import HeaderLinks from "./HeaderLinks.tsx";
import {ReactNode} from "react";

export default function FullscreenArticleView(props: { ArticleView?: ReactNode }) {
    return <div>
        <HeaderLinks as="div" />
        {props.ArticleView ?? <ArticleView/>}
    </div>
}